import React from "react";
import "./BookedAppointmentDetails.css";
import useTranslation from "../../hooks/use-translation";
import { useState, useEffect } from "react";
import BookedAppointmentCard from "./BookedAppointmentDetails";
import ErrorComponent from "../Error-Component";
import noAppointment from "../../images/no-appointments.svg";
import apiRequest from "../../utils/api.request";
import lodash from "lodash";
import config from "../../config.json";
import { useAppState } from "../../contexts/appState";
import { useHistory } from "react-router-dom";
import moment from "moment";
import { parseQueryString } from "../../utils/utils";
import useLoader from '../../hooks/use-loader';
import { srGetAppointmentList, srCancelAppointment } from '../../sources/my-appointments';
import { sendPageViewEvent } from '../../utils/network'
import ViewAppointmentDetails from "./Components/ViewAppointmentDetails";
import { vaccinationApiRequestBody } from "../VaccinationDetails/VaccinationDetailsWrapper/Utils/vaccinationApiRequestBody";
import BookErrorIcon from '../../images/Error_IMG.svg'

const appointmentData = require("./appointment_list.json"); //TODO:REMOVE
export const appointmentDataList = async () => Promise.resolve(appointmentData); //TODO:REMOVE

const MyAppointmentDetails = ({ type }) => {
  const { t } = useTranslation();
  const [noAppointments, setNoAppointments] = useState(false);
  const [onloadApiCall, setOnloadApiCall] = useState(true);
  const [showErrorComponent, _setShowErrorComponent] = useState(false);
  const [step, setStep] = useState(1);
  const [appointmentList, setAppointmentList] = useState([]);
  const [pastSingleDetail, setPastSingleDetail] = useState([]);
  const [appointmentDetails, _setAppointmentDetails] = useState();
  const [{ user }, dispatch] = useAppState();
  const history = useHistory();
  const { showLoading, hideLoading } = useLoader();

  const urlParams = new URLSearchParams(window.location.search);
  const params = parseQueryString();

  const source_id = lodash.get(params, "source_id");
  const auth_token = lodash.get(params, "auth_token");
  const source_user_id = lodash.get(params, "source_user_id");
  const source_relation = lodash.get(params, "source_relation");
  const source_user_relation_id = lodash.get(params, "source_user_relation_id");


  useEffect(() => {
    if (!source_id || !auth_token || !source_user_id || !source_relation || !source_user_relation_id) {
      history.push('/');
    } else {
      // if (window.location.pathname === '/my-appointment/scheduled') {
      //   sendPageViewEvent({ VirtualPageTitle: 'my-appointment/scheduled' })
      // } else {
      //   sendPageViewEvent({ VirtualPageTitle: 'my-appointment/vaccination-history' })
      // }
      const callAppointmentList = async () => {
        showLoading();
        const dataObj = {
          booking_jiohealthhubid: user.bookingHealthId,
          primary_jiohealthhubid: user.primaryHealthId,
          page: "1",
          per_page: "50",
          type: type,
        };

        const response = await srGetAppointmentList(dataObj);
        if (lodash.get(response, "status") !== "success") {
        } else {
          if (response?.contents) {
            const {
              contents: { appointment_list = null },
            } = response;
            setAppointmentList(appointment_list);
          }
        }
        setOnloadApiCall(false);
        hideLoading();
      };

      callAppointmentList();
      return () => { };
    }
  }, []);

  const formatDate = (date, showOnlyDate = false) => {
    if (showOnlyDate) {
      date = date && moment(date).format("DD/MM/YYYY");
    } else {
      date = date && moment(date).format("DD/MM/YYYY, hh:mm A");
    }

    return date;
  };

  const callCancelService = async (order_id) => {
    showLoading();
    const dataObj = {
      order_id: order_id,
      type: "cancel",
      reason_for_cancel: "Other",
      cancel_code: "4",
      booking_jiohealthhubid: user.bookingHealthId,
      primary_jiohealthhubid: user.primaryHealthId
    };

    const response = srCancelAppointment(dataObj);
    if (lodash.get(response, "status") !== "success") {
    } else {
      const responseCancelApi = response;
    }
    hideLoading();
  };

  const handleYesButton = (order_id) => {
    callCancelService(order_id);
    setNoAppointments(true);
  };
  const getVaccineNameDose = (data) => {
    let vaccineName = null;
    if (data?.vaccination_details?.vaccine_name && data?.vaccination_details?.dose_count) {
      vaccineName = data?.vaccination_details?.vaccine_name +
        ", " + t("DOSE") + data?.vaccination_details?.dose_count;
    } else if (data?.vaccination_details?.vaccine_name) {
      vaccineName = data?.vaccination_details?.vaccine_name
    }

    return vaccineName;
  };

  const _getAppointmentDetails = async (data) => {
    const getAppointmentDetailsUrl = config.covid_vacc_base_url + "booking/v2/appointment_details/";
    const userDetailsObj = {
      auth_token,
      source_id,
      source_user_id,
      source_relation,
      source_user_relation_id
    };
    const dataObj = vaccinationApiRequestBody({
      order_id: lodash.get(data, "order_id", ""),
      booking_jiohealthhubid: user.bookingHealthId,
      primary_jiohealthhubid: user.primaryHealthId,
    }, userDetailsObj);
    showLoading();
    setOnloadApiCall(true);
    const response = await apiRequest(getAppointmentDetailsUrl, dataObj, true);
    hideLoading();
    setOnloadApiCall(false);
    if (lodash.get(response, "status") !== "success") {
      _setShowErrorComponent(true);
      return;
    }
    const newAppointmentDetails = lodash.get(response, "contents");
    _setAppointmentDetails(newAppointmentDetails);
  }

  const viewDetailClick = async (data) => {
    await _getAppointmentDetails(data);

    // sendPageViewEvent({ VirtualPageTitle: 'my-appointment/vaccination-history/view-details' })
    // const pastSingleDetail = [
    //   { key: t("PATIENT_NAME"), value: data?.patient_details?.name },
    //   {
    //     key: t("APPOINTMENT_DATE_TIME"),
    //     value: formatDate(data?.booked_appointment_start_time),
    //   },
    //   { key: t("CENTER_DETAILS"), value: data?.hosiptal_details?.name },
    //   {
    //     key: t("VACCINE_NAME"),
    //     value: getVaccineNameDose(data),
    //   },
    //   { key: t("BOOKED_ORDER_DETAILS"), value: data?.order_id },
    //   { key: t("STATUS"), value: data?.appointment_status?.display_text },
    //   {
    //     key: t("NEXT_DOSE_DATE"),
    //     value: formatDate(data?.vaccination_details?.next_dose_datetime, true),
    //   },
    // ];
    // setPastSingleDetail(pastSingleDetail);
    setStep(2);
  };

  const goBackClick = () => {
    setStep(1);
  };
  const errorButtonClickCallback = () => {
    if (urlParams.get('reschedule')) {
      urlParams.delete('reschedule');
    }
    history.push(`/book-appointment/corporate?${urlParams.toString()}`);
  };
  const onRescheduleClick = (data) => {
    dispatch({
      type: "UPDATE_BOOKING",
      bookingData: {
        order_id: data?.order_id,
        partner_consult_center_id: data?.partner_consult_center_id,
        doctor_id: data?.doctor_id,
      }
    });

    dispatch({
      type: "SET_CENTER_DETAILS",
      centerDetails: {
        address: data?.hosiptal_details?.address
      }
    });
    history.push(
      `/book-appointment/corporate?reschedule=true&${urlParams.toString()}`
    );
  };

  const RenderAppointments = ({
    t,
    appointmentList = [],
    noAppointments = false,
  }) => (
    <div className={`${step !== 2 ? "my-appointment-main-container" : ""}`}>
      {appointmentList?.length === 0 || noAppointments ? (
        <ErrorComponent
          image={noAppointment}
          text={
            type === "upcoming"
              ? t("NO_APPOINTMENTS_TEXT_SCHEDULED")
              : t("NO_APPOINTMENTS_TEXT_HISTORY")
          }
          subText={t("NO_APPOINTMENTS_SUB_TEXT")}
          buttonText={t("BOOK_APPOINTMENT")}
          showButton={true}
          textCss="no-appointments-text"
          subTextCss="no-appointments-sub-text"
          buttonClickCallback={errorButtonClickCallback}
        />
      ) : (
        appointmentList?.map((data, i) => {
          const upcomingList = [
            {
              key: t("DATE_TIME"),
              value: formatDate(data?.booked_appointment_start_time),
            },
            {
              key: t("CENTER"),
              value: data?.hosiptal_details?.name
            },
            {
              key: t("STATUS"),
              value: data?.appointment_status?.display_text,
            },
          ];

          const pastList = [
            {
              key: t("DATE_TIME"),
              value: formatDate(data?.booked_appointment_start_time),
            },
            { key: t("CENTRE"), value: data?.hosiptal_details?.name },
            { key: t("STATUS"), value: data?.appointment_status?.display_text },
          ];
          return (
            <div key={i}>
              {type === "upcoming" && step === 1 && (
                <>
                  <BookedAppointmentCard
                    detailsList={upcomingList}
                    type={type}
                    handleYesClick={handleYesButton}
                    appointmentData={data}
                    rescheduleClick={onRescheduleClick}
                    qrCodeValue={data?.qr_code}
                    viewDetailClick={viewDetailClick}
                  />
                </>
              )}
              {type === "past" && (
                <>
                  {step === 1 && (
                    <>
                      <div className="">
                        <div className="book-appointment-history-container">
                          <BookedAppointmentCard
                            detailsList={pastList}
                            type={type}
                            viewDetailClick={viewDetailClick}
                            step={step}
                            appointmentData={data}
                          />
                        </div>
                      </div>
                    </>
                  )}
                </>
              )}
            </div>
          );
        })
      )}
    </div>
  );

  if (showErrorComponent) {
    return (
      <ErrorComponent
        image={BookErrorIcon}
        text={t('BOOK_ERROR_TEXT')}
        textCss='no-appointments-text'
        subTextCss='no-appointments-sub-text'
      />
    )
  } else {
    return (
      <>
        {!onloadApiCall && (

          <RenderAppointments
            appointmentList={appointmentList}
            t={t}
            noAppointments={noAppointments}
          />
        )}
        {/* {step === 2 && (
          <BookedAppointmentCard
            detailsList={pastSingleDetail}
            type={type}
            step={step}
            goBackClick={goBackClick}
          />
        )} */}
        {step === 2 && (typeof appointmentDetails !== "undefined") && (
          <ViewAppointmentDetails appointmentDetails={appointmentDetails} _backClick={goBackClick} handleYesClick={handleYesButton} rescheduleClick={onRescheduleClick} setStep={setStep} />
        )}

      </>
    );
  }
};

export default MyAppointmentDetails;
